export const copyTextToClipboard = async (texto: string): Promise<{success: boolean, error?: string}> => {
  try {
    await navigator.clipboard.writeText(texto)
    return {success: true}
  }
  catch(error: any) {
    return {success: false, error}
  }
}
